import { defineStore } from "pinia"
import validateOverlayMarkupInDOM from "foundation/js/validateOverlayMarkupInDOM"
import { disableScroll, enableScroll } from "components/Overlay/Overlay.helpers"
import { post } from "foundation/js/api"

const overlayDataDefaults = {
    showOverlay: false,
    overlayType: null,
    content: null,
    titleText: null,
    styles: null
}

const leadGateDataDefaults = {
    downloadPath: '',
    linkElement: null,
    guid: '',
}

export const useMainStore = defineStore('main', {
    state: () => ({
        test: 'testvalue',
        overlayData: structuredClone(overlayDataDefaults),
        primaryMenuMobileData: {},
        secondaryMenuMobileData: {},
        regionMenuData: [],
        leadGateData: structuredClone(leadGateDataDefaults),
        breakpoints: {
            tablet: 768
        },
        closeCallback: null,
    }),
    getters: {
        overlayContent(state) {
            return state.overlayData
        }
    },
    actions: {
        update(value) {
            this.test = value
        },
        clearOverlay() {
            this.overlayData = structuredClone(overlayDataDefaults)
            this.leadGateData.downloadPath = ''
            this.leadGateData.linkElement = null
            enableScroll()
            if (this.closeCallback) {
                this.closeCallback()
                setTimeout(() => {
                    this.closeCallback = null
                }, 100)
            }
        },
        changeOverlaySettings(settings = {showOverlay:false,overlayType:'',content:{}}) {
            console.log("overlay data",settings)

            validateOverlayMarkupInDOM()

            this.closeCallback = settings.closeCallback ?? null

            const overlayData = {}
            overlayData.showOverlay = settings.showOverlay
            overlayData.overlayType = settings.overlayType
            overlayData.content = settings.content
            overlayData.titleText = settings.titleText
            overlayData.styles = settings.styles

            this.overlayData = overlayData

            if(settings.showOverlay) disableScroll()
        },
        setPrimaryMenuMobileData(data) {
            this.primaryMenuMobileData = data
        },
        setSecondaryMenuMobileData(data) {
            this.secondaryMenuMobileData = data
        },
        setRegionMenuData(data) {
            this.regionMenuData.push(data)
        },
        setLeadGateData(data) {
            this.leadGateData.downloadPath = data.downloadPath ?? ''
            this.leadGateData.linkElement = data.linkElement ?? null
            this.leadGateData.guid = data.guid ?? this.leadGateData.guid ?? ''
        },
        submitLeadGateForm(payload) {
            console.log('submitLeadGateForm', payload.body)
            let url = `${document.location.origin}/${process.env.LEAD_GATE_FORM.replace("[guid]", this.leadGateData.guid)}`

            const response = post(url, JSON.stringify(payload.body))
        }
    }
})
